 function getScript(url, callback) {
   const doc = document;
   const head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
   const node = doc.createElement('script');
   node.setAttribute('charset', 'utf-8');
   if ('onload' in node) {
     node.onload = function () {
       callback(1);
     };
     node.onerror = function () {
       callback(0);
     };
   } else {
     node.onreadystatechange = function () {
       if (/loaded|complete/.test(node.readyState)) {
         callback(1);
       }
     };
   }
   node.async = true;
   node.src = url;
   head.appendChild(node);
 }

 function addStyle(url) {
   const head = document.getElementsByTagName('head')[0];
   const link = document.createElement('link');
   link.id = 'alicarecss';
   link.rel = 'stylesheet';
   link.type = 'text/css';
   link.href = url;
   link.media = 'all';
   head.appendChild(link);
 }

 export { getScript, addStyle };



// WEBPACK FOOTER //
// ./src/app/assets.js